import { FETCH_NETWORK_ERROR } from "./fetch";
import _isObject from "lodash/isObject";

const l10nErrors: { [key: string]: string } = {
  'validation.required':    'Обязательное поле',
  'validation.email':       'Некорректный email',
  'validation.email_taken': 'Данный email уже существует в системе',
  'validation.unique':      'Данный email уже существует в системе',
  'validation.min.string':  'Минимальная длина пароля 6 символов',
  'validation.confirmed':   'Пароли не совпадают',
  'validation.phone':       'Некорректный телефон',
  'validation.length':      'Некорректный телефон',
  'validation.not_in':      'Некорректное значение',
  'login_failed':           'Неверные Email/Пароль',
  'not_found':              'Email не найден',
  'network_error':          'Ошибка сети',
  'unknown_error':          'Неизвестная ошибка',
  [FETCH_NETWORK_ERROR]:    'Ошибка сети',
};

export const l10nError = (error: string | string[] | Record<string, string | string[]>): string => {
  if (_isObject(error)) error = Object.values(error).map(e => Array.isArray(e) ? e.join(', ') : e);
  if (Array.isArray(error)) return error.map(l10nError).join(', ');
  // if (typeof error !== 'string') error = error.toString();
  return l10nErrors.hasOwnProperty(error) ? l10nErrors[error] : error;
};
